import React, {useState, useEffect} from "react";
import {PDFDownloadLink, Document, Page, View, Text, Image, Font, StyleSheet} from '@react-pdf/renderer';
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";

import {useTranslation} from "react-i18next";
import source1Font from "../../../assets/fonts/futura-book.otf";
import source2Font from "../../../assets/fonts/futura-medium.woff";
import source3Font from "../../../assets/fonts/futura-bold.woff";

Font.register({
    family: 'Futura',
    fonts: [{src: source1Font}, {src: source2Font, fontWeight: 500}, {src: source3Font, fontWeight: 700},]
});
Font.registerHyphenationCallback(word => [word]);
const layout = {
    labelCol: {
        span: 8,
    }, wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8, span: 16,
    },
};
const styles = StyleSheet.create({
    page: {
        paddingBottom: 45, backgroundColor: "#ffffff",
    }, pageRes: {
        paddingBottom: 45, backgroundColor: "#ffffff",
    }, headerSection: {
        flexDirection: "row",
    }, table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    }, tableRow: {margin: "auto", flexDirection: "row"}, tableCol: {
        width: "50%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0,
    }, tableCell: {
        margin: "auto", marginTop: 8, marginBottom: 8, fontSize: 10
    },
});

const stylesPdf = StyleSheet.create({
    page: {
        backgroundColor: 'white', fontFamily: 'Futura', fontSize: 14
    }, titleOne: {
        color: '#1C2E36', textAlign: 'center', marginTop: 12, fontSize: 16, fontWeight: 700, lineHeight: "175%"
    }, subtitle: {
        color: '#1C2E36', textAlign: 'center', fontSize: 16, fontWeight: 400
    }, spacetext: {
        marginTop: 8, marginBottom: 0
    }, spacetextxs: {
        marginTop: 4, marginBottom: 0
    }, step: {
        color: '#1C2E36',
        textAlign: 'justify',
        marginTop: 8,
        marginLeft: 24,
        marginRight: 24,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.5
    }, headerTable: {
        marginTop: 16,
        marginLeft: 24,
        marginRight: 24,
        padding: 8,
        backgroundColor: "#FFB81C",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderColor: "#a5adbb",
        borderTopWidth: 1,
        borderRightWidth: 1,
        borderLeftWidth: 1,
    }, h1HeaderTable: {
        fontSize: 12,
        fontWeight: 500,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: "167%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    }, columnWidth60: {
        width: "60%",
    }, columnWidth40: {
        width: "40%",
    }, rowheadercolor: {
        display: "table",
        width: "auto",
        marginRight: 8,
        marginLeft: 8,
        borderWidth: 1,
        borderColor: "#FFB81C",
        padding: 0,
        borderTopRightRadius: 30,
        borderTopLeftRadius: 30
    },

    rowheader: {
        display: "table", width: "auto", borderWidth: 0, marginRight: 8, marginLeft: 8
    }, rowTable: {
        marginLeft: 24,
        marginRight: 24,
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8
    }, colTable: {
        width: "50%",
        padding: 8,
        backgroundColor: "#ffffff",
        fontSize: 12,
        marginLeft: 0,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: 1,
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderTopWidth: 1
    }, colTableBottomL: {
        borderBottomLeftRadius: 8,
    }, colTableBottomR: {
        borderBottomRightRadius: 8
    }, colBorderCenter: {
        borderLeftWidth: 1, borderColor: "#a5adbb"
    },  footer: {
        margin: 16,
        fontSize: 9,
        textAlign: "center",
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
    }, footerFirstPage: {
        marginTop: 16, marginRight: 16, marginBottom: 56, marginLeft: 16, fontSize: 9, textAlign: "center"
    }, imagelogoheader: {
        width: 90,
    }, imageLogoCenter: {
        width: 172, marginBottom: 16
    }, imageReportCenter: {
        width: 154, height: 154, marginBottom: 24
    }, titlePortada: {
        fontSize: 20, marginBottom: 8
    }, subtitlePortada: {
        fontSize: 20, fontWeight: 700, textTransform: "uppercase"
    }, numberPage: {
        position: 'absolute', bottom: 24, right: 24, textAlign: 'right', color: '#1C2E36', fontSize: 10
    }, link: {
        color: "#20388f"
    }, pageBackground: {
        position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, zIndex: 0,
    }, pageBackgroundFooter: {
        position: 'absolute', right: 0, bottom: 0, left: 0, zIndex: 0, height: 40
    }, lineText: {
        display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center"
    }, lineText2: {

        display: "flex", flexDirection: "row",
    },

    strongText: {
        fontWeight: 500
    }, strongText2: {
        fontSize: 11, fontWeight: 500
    }, strongText3: {
        fontSize: 14, fontWeight: 500
    }, paddingTextCenter: {
        paddingTop: 6, fontSize: 11
    }, marginT4: {
        marginTop: 4
    }
});
const MyDoc = ({t, props, i18n,images}) => (
    <Document>
        <Page>
            <View style={stylesPdf.rowheader}>
                <View style={{marginTop: 15, flexDirection: "row",backgroundColor: "#FAFAFA", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                    <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                        <Text style={stylesPdf.h1HeaderTable}>{t("datos.muestra")}: </Text>
                    </View>
                </View>
                <View style={{flexDirection: "row",
                    borderBottom: 1, borderBottomColor: '#FAFAFA',
                    borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                    <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.strongText2}>{t("datos.tamanyo")}: </Text>
                        </View>
                    </View>
                    <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.paddingTextCenter}>{props.totalAlumnos} {t("datos.alumnos")}</Text>
                        </View>
                    </View>
                </View>

                <View style={{flexDirection: "row",
                    borderBottom: 1, borderBottomColor: '#FAFAFA',
                    borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                    <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.strongText2}>{t("datos.tipoin")}: </Text>
                        </View>
                    </View>
                    <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.paddingTextCenter}>{props.tipoInforme}</Text>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection: "row",
                    borderBottom: 1, borderBottomColor: '#FAFAFA',
                    borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                    <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.strongText2}>{t("login.course")}: </Text>
                        </View>
                    </View>
                    <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.paddingTextCenter}>{props.course}</Text>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection: "row",
                    borderBottom: 1, borderBottomColor: '#FAFAFA',
                    borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                    <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.strongText2}>{t("datos.year")}: </Text>
                        </View>
                    </View>
                    <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.paddingTextCenter}>{props.year}</Text>
                        </View>
                    </View>
                </View>
            </View>
            {props.isTek ?
                images.map((it,i) => {

                    return   (<View>
                        <View style={{flexDirection: "row",width: "90%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}><Image
                            style={{
                                width: "540px",

                                marginRight: "2px",
                                border: "0px solid #13a59f",
                                padding: "5px",
                            }}
                            src={images[i][0]}
                        /></View>
                        {images[i][1] &&
                            <View style={{flexDirection: "row",width: "90%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}><Image
                                style={{
                                    width: "540px",
                                    marginRight: "2px",
                                    border: "0px solid #13a59f",
                                    padding: "5px",
                                }}
                                src={images[i][1]}
                            /></View>
                        }

                    </View>)
                })
            :
                images.map((it,i) => {

                    return   (<View style={{flexDirection: "row",}}>
                        <View style={{width: "50%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}><Image
                            style={{
                                height: "360px",

                                marginRight: "5px",
                                border: "0px solid #13a59f",
                                padding: "5px",
                            }}
                            src={images[i][0]}
                        /></View>
                        {images[i][1] &&

                            <View style={{width: "50%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}><Image
                                style={{
                                    height: "360px",

                                    marginRight: "5px",
                                    border: "0px solid #13a59f",
                                    padding: "5px",
                                }}
                                src={images[i][1]}
                            /></View>
                        }

                    </View>)
                })
            }



        </Page>
    </Document>
);

function DownloadGraficos(props) {
    const {t, i18n} = useTranslation();

    const download = (filename, url) => {
        const element = document.createElement('a');
        element.setAttribute('href', `${url}`);
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };


    const callToLink = (url, blob) => {
        if (url && blob) {
            const href = window.URL.createObjectURL(blob);

            window.open(href, "_blank", "noreferrer");
        }

    }

    return (
        <>


            <PDFDownloadLink className={"btnWhiteBlue ant-btn ant-btn-default" } document={<MyDoc  t={t}
                                               props={props}
                                               i18n={i18n} images={props.images} />} fileName={props.tipoInforme + ".pdf"}>
                {({ blob, url, loading, error }) => {
                    //if (!loading) {
                      //  callToLink(url, blob)
                    return loading ? t("datos.generandoi"): t("datos.descargai")
                }}

            </PDFDownloadLink>
        </>
    );
}

export default withTranslation()(DownloadGraficos);
